import { inject, Injectable } from '@angular/core';
import { CreatePhotoCommentInput, CreatePhotoCommentMutation } from '../queries/generated';
import { map } from 'rxjs';
import { finalMap } from '../rx/final-map';

@Injectable({
  providedIn: 'root'
})
export class PhotoCommentsService {
  private readonly createPhotoCommentMutation = inject(CreatePhotoCommentMutation);

  create(input: CreatePhotoCommentInput) {
    return this.createPhotoCommentMutation.mutate({ input }).pipe(
      map(({ data }) => data.createPhotoComment),
      finalMap('photoComment')
    );
  }
}
